import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  default: {
    firm: null,
    calibrate: null,
    calibrateType: null,
    contact: null,
    fleetNumber: '',
    insurance: null,
    fleetContact: null,
    notes: '',
    ronumber: '',
    vehicle: {
      vehicle: null,
      firm: null,
      contact: null,
      year: '2020',
      make: null,
      model: '',
      vin: ''
    },
    estimator: null,
    createdBy: null,
    status: 1
  },
  defaultEvent: {
    calibrateEvent: null,
    firm: null,
    firmName: null,
    ronumber: null,
    createdBy: null,
    calibrate: null,
    calibrateEventType: null,
    calibrateStatusType: null,
    scheduled: null,
    bay: null,
    started: null,
    completed: null,
    notes: '',
    results: '',
    internalNotes: '',
    techIds: null,
    calibrateReadyIds: null,
    transportationTypeIds: null,
    calibratePrecheckIds: null,
    calibrateServiceIds: null,
    calibrateActionIds: null,
    calibrateVerifyIds: null,
    state: null,
    skipReady: false,
    skipPrecheck: false,
    skipActions: false,
    serviceList: [],
    readyList: [],
    precheckList: [],
    actionList: [],
    verifyList: [],
    paymentType: null,
    paymentTypeName: null,
    techSelected: false,
    serviceFirm: null,
    calibrateEventReference: null,
    creditNotes: null,
    creditList: []
  },
  pageSize: storage.local.getItem(types.CALIBRATE_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.CALIBRATE_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.CALIBRATE_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.CALIBRATE_ORDER_BY) || 'lastEventDate',
  filterBy: storage.local.getItem(types.CALIBRATE_FILTER_BY) || '2,3,8,10,11',
  filterOptions: [],
  // dateRange: null,
  dateStart: storage.session.getItem(types.CALIBRATE_DATESTART) || null,
  dateEnd: storage.session.getItem(types.CALIBRATE_DATEEND) || null,
  viewBy: storage.local.getItem(types.CALIBRATE_VIEW_BY) || 1,
  technician: storage.local.getItem(types.CALIBRATE_TECHNICIAN) || null,
  locationCalibrates: [],
  calibrates: [],
  calibrate: null,
  calibrateEvents: [],
  calibrateRequests: [],
  calibrateEvent: null,
  calibrateEventCurrent: null,
  highlightSave: false,
  isCalibrateChecked: false,
  calibrateServiceRates: [],
  repairlines: [],
  scans: [],
  calibrateCounts: {
    pending: null,
    completed: null,
    inProcess: null,
    scheduled: null
  },
  showAll: 0,
  isChange: false,
  pendingStatusChange: null,
  isCalibrateEventDialog: false,
  requestServices: [],
  invoicePreferences: null,
  pendingServiceIds: [],
  refreshRate: storage.local.getItem(types.CALIBRATE_REFRESH_RATE) || 10,
  refreshRates: [
    {
      id: 1,
      name: '1 minute',
      value: 1
    },
    {
      id: 2,
      name: '2 minutes',
      value: 2
    },
    {
      id: 3,
      name: '3 minutes',
      value: 3
    },
    {
      id: 4,
      name: '4 minutes',
      value: 4
    },
    {
      id: 5,
      name: '5 minutes',
      value: 5
    },
    {
      id: 6,
      name: '10 minutes',
      value: 10
    },
    {
      id: 7,
      name: '20 minutes',
      value: 20
    },
    {
      id: 8,
      name: '30 minutes',
      value: 30
    },
    {
      id: 9,
      name: '45 minutes',
      value: 45
    },
    {
      id: 10,
      name: '1 hour',
      value: 60
    },
    {
      id: 11,
      name: '2 hours',
      value: 120
    },
    {
      id: 12,
      name: '3 hours',
      value: 180
    }
  ],
  pricingRuleResults: []
})



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/state.js